import React from 'react'
import PropTypes from 'prop-types'
import { useConnect } from 'sb-redux-hook'
import { useMemo, useFeatures } from 'sb-hooks'
import { compose, constants, string, getShippingText,
  isOnlyPerfumeCasesInCartSelector } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'


const Title = ({ intl, cart, paymentType, isEcommerceErrorExist, ecommerceErrorMessage, isTossIn }) => {
  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()

  const { isOnlyPerfumeCases } = useConnect({
    isOnlyPerfumeCases: isOnlyPerfumeCasesInCartSelector(Object.values(cart.products.items)),
  })

  const ecommerceMessage = useMemo(() => (
    isOnlyPerfumeCases ? messages.perfumeCaseText : messages.ecommerce
  ), [ isOnlyPerfumeCases ])

  if (isEcommerceErrorExist) {
    const errorMessage = Boolean(ecommerceErrorMessage)
      ? ecommerceErrorMessage
      : intl.formatMessage(messages.anErrorOccurred)

    return (
      <Text
        tag="h2"
        message={messages.orderDidntGo}
        values={{ text: errorMessage }}
        size="28-40"
        dataTestId={constants.testIds.thankYouPage.title}
      />
    )
  }

  const shippingText = string.capitalize(getShippingText(new Date(), isBillingDay1stEnabled))

  if (paymentType === constants.paymentTypes.subscriptionAndEcommerce) {
    return (
      <h2 data-testid={constants.testIds.thankYouPage.title}>
        <Box mb="8">
          <Text
            message={messages.subscription}
            values={{ shippingText }}
            size="28-40"
            semibold
          />
        </Box>
        <Text size="28-40" message={ecommerceMessage} semibold />
      </h2>
    )
  }

  if (paymentType === constants.paymentTypes.ecommerce) {
    return (
      <Text
        tag="h2"
        message={isTossIn ? messages.tossIn : ecommerceMessage}
        size="28-40"
        semibold
        dataTestId={constants.testIds.thankYouPage.title}
      />
    )
  }

  let title = messages.returnToSite

  if (paymentType === constants.paymentTypes.subscription) {
    title = {
      ...messages.subscription,
      values: {
        shippingText,
      },
    }
  }
  else if (messages[paymentType]) {
    title = messages[paymentType]
  }

  return (
    <Text
      tag="h2"
      message={title}
      size="28-40"
      semibold
      dataTestId={constants.testIds.thankYouPage.title}
    />
  )
}

Title.propTypes = {
  intl: PropTypes.object, // @injectIntl
  paymentType: PropTypes.string.isRequired,
  ecommerceErrorMessage: PropTypes.string,
  isEcommerceErrorExist: PropTypes.bool,
}

export default compose(
  injectIntl,
)(Title)
